import $ from 'jquery';
import { addToggleButtonEventListeners } from './site/helpers';

const categories = window.categories;
const categoryTitle = document.getElementById('category_title');
const categoryDetail = document.getElementById('category_detail');
const categoryLink = document.getElementById('category_link');
const slider = $('[data-carousel="multiple"]');

// TODO: DRY
const filterButtons = document.querySelectorAll('.filter-button');
let selectedCategory = null; 
if (filterButtons.length > 0) {
  const firstButton = filterButtons[0];
  const category = firstButton.getAttribute('data-category');
  selectedCategory = category;
  firstButton.classList.add('active');
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('categoryClick', (event) => {
    selectedCategory = event.detail.category;
    categoryTitle.textContent = categories[selectedCategory].name;
    categoryDetail.textContent = categories[selectedCategory].description;
    categoryLink.href = `/category/${selectedCategory}`;
  });

  categoryTitle.textContent = categories[selectedCategory]?.name;
  categoryDetail.textContent = categories[selectedCategory]?.description;
  categoryLink.href = `/category/${selectedCategory}`;
  const cards = document.querySelectorAll('.our-work-card');
  let cardWidth;

  const updateCardWidth = () => {
    cards.forEach((card) => {
      cardWidth = card.offsetWidth;
      card.setAttribute('data-card-width', cardWidth); // Optional: Store cardWidth for debugging
    });
  };

  updateCardWidth();
  window.addEventListener('resize', updateCardWidth);
  addToggleButtonEventListeners(cards, cardWidth);
  slider.on('beforeChange', (event) => {
    const openSlides = document.querySelectorAll('.our-work-card.open');
    openSlides.forEach((slide) => {
      slide.querySelector('.show-read-more').click();
    });
  });
  // slider.on('afterChange', addToggleButtonEventListeners(document.querySelectorAll('.our-work-card'), cardWidth));

  // Initial Filtering - adding this at the end or else filtered cards wont get event listeners
  // TODO: this should be moved out into a helper function
  slider.slick('slickFilter', function (index) {
    const card = $(this).find('.our-work-card');
    const categories = card.data('category');
  
    return index === 0 || (categories && categories.split(' ').includes(selectedCategory));
  })
});

